function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _Dialoger from "@kibt/meta-ui/es/dialog/dialoger";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import yoda from '@ks/yoda-js-sdk';
import * as qs from 'querystring';
import { jumpOneLinkForCommon } from './jump-link';
import { handleError } from './handle-error';
import { myhttp } from './http';
import { isInApp } from '@/utils/yoda';
import i18n from '@/utils/common-k18n';
// 端内端外两个接口
export var getApi = function getApi(str) {
  if (process.env && process.env.VUE_APP_RUNTIME_ENV === 'staging') {
    var mockIsInApp = new URL(window.location.href).searchParams.get('isInApp');
    var state = getQueryState();
    if (mockIsInApp) {
      return str;
    }
    if (state) {
      mockIsInApp = state.isInApp;
      if (mockIsInApp) {
        return str;
      }
    }
  }
  if (!isInApp) {
    return str.endsWith('/') ? "".concat(str, "oa") : "".concat(str, "/oa");
  }
  return str;
};
// 业务cookie
export function setMyCookie() {
  return _setMyCookie.apply(this, arguments);
}
function _setMyCookie() {
  _setMyCookie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var ret;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return myhttp.get('/rest/o/w/creator/exchange/metadata/oa');
          case 2:
            ret = _context3.sent;
            return _context3.abrupt("return", ret);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _setMyCookie.apply(this, arguments);
}
export function setLoginApi(_x) {
  return _setLoginApi.apply(this, arguments);
}
// 需求场景为端外需要登录时用到（调用这个方法不会影响端内）
function _setLoginApi() {
  _setLoginApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(code) {
    var ret;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return myhttp.post('/rest/o/w/login/login_by_app', qs.stringify({
              code: code,
              client_id: 'kwai_web_creative'
            }), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            });
          case 2:
            ret = _context4.sent;
            return _context4.abrupt("return", ret);
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _setLoginApi.apply(this, arguments);
}
export var setLogin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var code, ret, currentUrl, targetUrl, ret2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            code = new URL(window.location.href).searchParams.get('code'); // 端外并且链接上有code
            if (!(!yoda.isInYoda && code)) {
              _context2.next = 24;
              break;
            }
            _context2.next = 4;
            return setLoginApi(code);
          case 4:
            ret = _context2.sent;
            // 下面是为了删除当前url上的code参数
            currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('code');
            targetUrl = currentUrl.href;
            window.history.replaceState({
              action: 'delete-params',
              params: ['code']
            }, '', targetUrl);
            // 验证码错误，或者服务异常
            if (!(ret.result === 1001)) {
              _context2.next = 13;
              break;
            }
            _Dialoger.alert({
              content: i18n.t('creator_scout_net_error'),
              okText: i18n.t('common_ok'),
              onOk: function () {
                var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          document.documentElement.setAttribute('api', 'ok');
                          toAppLogin();
                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                function onOk() {
                  return _onOk.apply(this, arguments);
                }
                return onOk;
              }(),
              maskClosable: false
            });
            _context2.next = 24;
            break;
          case 13:
            if (!(ret.result !== 1)) {
              _context2.next = 18;
              break;
            }
            _context2.next = 16;
            return handleError(ret, true);
          case 16:
            _context2.next = 24;
            break;
          case 18:
            _context2.next = 20;
            return setMyCookie();
          case 20:
            ret2 = _context2.sent;
            if (!(ret2.result !== 1)) {
              _context2.next = 24;
              break;
            }
            _context2.next = 24;
            return handleError(ret, true);
          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function setLogin() {
    return _ref.apply(this, arguments);
  };
}();
var paramsToObject = function paramsToObject(entries) {
  var result = {};
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      // each 'entry' is a [key, value] tupple
      result[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
var canParse = function canParse(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (_) {
    console.error("state:".concat(str, "\u4E0D\u80FD\u88ABJSON.parse"));
    return false;
  }
};
var objectAddToParams = function objectAddToParams(Url, obj) {
  Object.keys(obj).forEach(function (key) {
    Url.searchParams.set('key', obj[key]);
  });
};
export var toAppLogin = function toAppLogin(redirectUriParam) {
  var redirectURI = new URL(redirectUriParam || window.location.href);
  // 把链接上原来的state处理掉
  var redirectURIState = redirectURI.searchParams.get('state');
  redirectURI.searchParams.delete('state');
  var state = {};
  if (redirectURIState && canParse(redirectURIState)) {
    state = JSON.parse(redirectURIState);
  }
  var entries = redirectURI.searchParams.entries();
  // 将redirectURI上的所有参数当作key，value和redirectURI上的state参数合并
  state = _objectSpread(_objectSpread({}, state), paramsToObject(entries));
  // 正式地址为https://app.kwai.com/jump/authorize
  // staging域名https://feat-czj-commonlogin--kwai-main-app.jinx.staging.kuaishou.com
  // prt域名为ttps://kwai-main-app-feat-czj.kproxy.corp.kuaishou.com
  var jumpUrl = new URL('https://app.kwai.com/jump/authorize');
  jumpUrl.searchParams.set('redirect_uri', redirectURI.origin + redirectURI.pathname);
  jumpUrl.searchParams.set('client_id', 'kwai_web_creative');
  jumpUrl.searchParams.set('state', JSON.stringify(state));
  jumpUrl.searchParams.set('hyId', 'authorize');
  jumpUrl.searchParams.set('__launch_options__', JSON.stringify({
    topBarPosition: 'fixed'
  }));
  jumpOneLinkForCommon(jumpUrl.href);
};
export var getQueryState = function getQueryState() {
  var stateStr = new URL(location.href).searchParams.get('state');
  var state = stateStr ? JSON.parse(stateStr) : null;
  return state;
};